<template>
  <v-dialog :value="value" max-width="720" scrollable @input="$emit('input', $event)">
    <v-card class="change-dialog" @click.stop>
      <v-card-title>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon aria-label="Close" title="Close" @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <div v-if="loading" class="pa-6 text-center" role="status">
          <v-progress-circular indeterminate size="24" class="mr-2"></v-progress-circular>
          Loading commits...
        </div>
        <v-alert v-else-if="error" type="error" text class="ma-4" role="alert">{{ error }}</v-alert>
        <div v-else-if="!changes.length" class="pa-6 text-center">No commits found.</div>
        <v-list v-else two-line>
          <template v-for="(change, index) in changes">
            <v-list-item :key="change.hash">
              <v-list-item-avatar>
                <img v-if="change.authorAvatarUrl" :src="change.authorAvatarUrl" :alt="change.authorName">
                <v-icon v-else>mdi-account-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="change-message">
                  <template v-for="(part, partIndex) in messageParts(change.message)">
                    <a v-if="part.ticket" :key="`${change.hash}-part-${partIndex}`" class="ticket-link"
                      :href="`https://dericon.atlassian.net/browse/${part.text}`" target="_blank"
                      rel="noopener noreferrer" @click.stop>{{ part.text }}</a>
                    <span v-else :key="`${change.hash}-part-${partIndex}`">{{ part.text }}</span>
                  </template>
                </v-list-item-title>
                <v-list-item-subtitle>{{ change.authorName }} · {{ formatDate(change.date) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < changes.length - 1" :key="`${change.hash}-divider`"></v-divider>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions v-if="error && !loading">
        <v-spacer></v-spacer>
        <v-btn text color="#42b983" @click="$emit('retry')">Retry</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CommitChangesDialog',
  props: {
    value: Boolean,
    title: String,
    changes: { type: Array, default: () => [] },
    loading: Boolean,
    error: { type: String, default: '' }
  },
  methods: {
    formatDate(value) {
      const date = new Date(value);
      if (value == null || Number.isNaN(date.getTime())) return 'Unknown date';
      return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false
      }).format(date);
    },
    messageParts(message) {
      const ticketPattern = /\b[A-Z]{2,3}-\d+\b/g;
      const parts = [];
      let start = 0;
      let match;
      while ((match = ticketPattern.exec(message)) !== null) {
        if (match.index > start) parts.push({ text: message.slice(start, match.index), ticket: false });
        parts.push({ text: match[0], ticket: true });
        start = match.index + match[0].length;
      }
      if (start < message.length) parts.push({ text: message.slice(start), ticket: false });
      return parts;
    }
  }
}
</script>

<style scoped>
.change-message {
  white-space: pre-wrap;
  text-align: left;
}
.change-dialog .v-card__title,
.change-dialog .v-list-item__subtitle {
  text-align: left;
}
.ticket-link {
  color: #e7a34d;
  font-weight: bold;
  text-decoration: none;
}
.ticket-link:hover,
.ticket-link:focus {
  text-decoration: underline;
}
</style>
